import { Suspense, lazy } from 'react';
import Loader from '../customs/Customspinner/spinner';

const Main = lazy(() => import('../components/resetPassword/main')); 

const ResetPassword = () => {
    return (
        <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
    )
}

export default ResetPassword;